<div class="table-container mat-mdc-card">
  
  @if(!timeline){
  <div><code>Loading...</code></div>
  }
  @else{
  <div class="container">
    <ul class="level-1">
      @for( date of timeline.dates; track $index){
      <li class="title"><mat-icon>calendar_month</mat-icon> {{date.date | date:'EEEE, MMM dd yyyy'}}</li>
      <li class="children">
        @for( change of date.changes;track $index){
        <ul class="level-2">
          <li class="title">
            <mat-icon>schedule</mat-icon><span> {{change.timeUtc | date:'hh:mm a'}} : {{change.userName}} {{change.changeText}}</span>
            @if(change.formId){
            <a [routerLink]="`/main/form/${change.formPct}/${change.formId}/${clientId()}/${change.formVisitId}`"><mat-icon>link</mat-icon></a>
            }
          </li>
          <li class="children">
            <ol>
              @for( subchange of change.subChanges; track $index){
              <li>{{subchange}}</li>
              }
            </ol>
          </li>
        </ul>
        }
      </li>
      }

    </ul>

  </div>
  }

</div>
